export function apiErrorProgress(e: any) {
    try {
        const errorBody = JSON.parse(e.request.response)
        return errorBody.error.message
    } catch (e: any) {
        return e.message
    }
}